<template>
  <div class="p-0 overflow-hidden h-100">
    <Carousel
      ref="myCarousel"
      class="w-100 p-0 h-100 m-0 position-absolute top-0"
      id="car"
      v-model="slideIndex"
      :autoplay="5000"
    >
      <Slide class="p-0 slide">
        <div class="ci-green-bg pt-5 w-100">
          <h1 class="text-center text-white fw-bold mt-5">
            {{ t("PAYJOY_CARD_VIEWS.CARD_INTRO_TUTORIAL.YOUR_PAYJOY_CARD") }}
          </h1>
          <ul class="text-white fs-4 mt-5 me-1">
            <li
              v-html="t('PAYJOY_CARD_VIEWS.CARD_INTRO_TUTORIAL.INTRO_BULLET_1')"
            ></li>
            <li
              v-html="t('PAYJOY_CARD_VIEWS.CARD_INTRO_TUTORIAL.INTRO_BULLET_2')"
            ></li>
            <li
              v-html="t('PAYJOY_CARD_VIEWS.CARD_INTRO_TUTORIAL.INTRO_BULLET_3')"
            ></li>
          </ul>
          <div class="bottom-0 start-0 end-0 w-100 mt-auto mb-0">
            <img
              :src="useAsset('img/credit-line/card_intro_1.png')"
              alt="card intro 1"
              class="mx-auto"
            />
          </div>
        </div>
      </Slide>
      <Slide class="p-0 slide">
        <div class="pt-5 w-100 position-relative">
          <p
            class="text-center text-black fs-4 w-100 start-0 px-2 pt-5"
            v-html="t('PAYJOY_CARD_VIEWS.CARD_INTRO_TUTORIAL.AVAILABLE_CREDIT')"
            style="font-size: 20px; font-weight: 400; top: 20%"
          ></p>
          <div
            class="mt-auto position-absolute mb-0 bottom-0 start-0 end-0 w-100"
          >
            <img
              :src="useAsset(availableCreditGifPath)"
              alt="available credit gif"
              class="mx-auto w-100 mt-auto mb-0"
              style="object-fit: contain !important; z-index: -1000"
            />
          </div>
        </div>
      </Slide>
      <Slide class="p-0 slide">
        <div class="ci-green-bg pt-5 w-100">
          <p
            class="text-center text-white fs-4 w-100 px-2 mt-5"
            v-html="t('PAYJOY_CARD_VIEWS.CARD_INTRO_TUTORIAL.SWIPE_CARD')"
            style="font-size: 20px; font-weight: 400; top: 20%"
          ></p>
          <div class="w-100 bottom-0 mt-auto mb-0">
            <img
              :src="useAsset('img/credit-line/card_usage.webp')"
              alt="available credit gif"
              class="mx-auto w-100"
              style="object-fit: contain !important; z-index: -1000"
            />
          </div>
        </div>
      </Slide>

      <template #addons="{ currentSlide }">
        <section
          class="position-absolute top-0 w-100 d-flex flex-row shadow-none"
        >
          <div id="dots" class="mt-5 position-relative">
            <span
              v-for="index in [0, 1, 2]"
              :class="[
                index === currentSlide ? 'active-dot' : 'dot',
                currentSlide % 2 === 0 &&
                  index === currentSlide &&
                  'contrasted-item',
                index < currentSlide ? 'dot' : '',
              ]"
              :key="index"
              @click="switchSlide(index)"
            ></span>
          </div>
        </section>
        <button
          id="redirect-btn"
          class="position-fixed"
          @click="redirect"
          v-if="isLastSlide"
        >
          {{ t("PAYJOY_CARD_VIEWS.CARD_INTRO_TUTORIAL.REDIRECT_BTN") }}
        </button>
      </template>
    </Carousel>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import { Carousel, Slide } from "vue3-carousel";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { useRouter } from "vue-router";

const myCarousel = ref();
const { t, locale } = useI18n();
const slideIndex = ref(0);
const router = useRouter();
const SLIDES_LENGTH = 3;
const isLastSlide = computed(() => slideIndex.value === SLIDES_LENGTH - 1);
const availableCreditGifPath = computed(() =>
  locale.value.substring(0, 2) === "en"
    ? "img/credit-line/available_credit_en.webp"
    : "img/credit-line/available_credit_es.webp"
);

const redirect = () => router.push({ name: "CreditCardDetailsView" });

const switchSlide = (newIndex: number) => {
  if (newIndex <= SLIDES_LENGTH) {
    myCarousel?.value?.slideTo(newIndex);
    slideIndex.value = newIndex;
  }
};

onMounted(() => {
  document.querySelectorAll(".slide > div:first-child")?.forEach((slide) => {
    slide.style.height = window.innerHeight + "px";
  });
});

setInterval(() => {
  let x = document.getElementsByClassName("carousel__track")[0] as HTMLElement;
  if (x) {
    x.style.marginBottom = "0";
  }
}, 500);
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
body {
  overflow-y: hidden !important;
}
.slide {
  width: 100%;
}
#application-btn {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  border: none;
  bottom: 3%;
  text-align: center;
  width: 90%;
  border-radius: 10px !important;
  background: #336417;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.32);
}

#slide-text {
  margin-left: auto;
  margin-right: auto;
  padding-left: 10%;
  padding-right: 10%;
  left: 0;
  right: 0;
  top: 10%;
  text-align: center;
  font-size: x-large;
}

#slide-text span {
  font-weight: bolder;
  color: black;
}

.ci-green-bg {
  background: #2c7040;
}

#dots {
  margin-left: auto;
  margin-right: auto;
  top: 18%;
  width: 85%;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.dot {
  height: 10px;
  width: 10px;
  border-radius: 100px;
  background: rgba(17, 17, 17, 0.16);
  display: inline-block;
  margin-left: 2.5%;
}

.dot-activated {
  height: 10px;
  width: 10px;
  border-radius: 100px;
  background-color: #2c7040;
  filter: contrast(1);
  display: inline-block;
  margin-left: 2.5%;
}

.contrasted-item {
  background-color: white !important;
}

.white-item {
  color: white !important;
}

.active-dot {
  height: 10px;
  width: 20px;
  border-radius: 100px;
  background: #2c7040;
  display: inline-block;
  margin-left: 2.5%;
  transition: width 0.3s ease-out;
}

.number-dot {
  width: 25px;
  height: 25px;
  background: rgba(255, 242, 242, 0.49);
  border: 1px solid $pj-color-black;
  box-sizing: border-box;
  margin-left: 5%;
  margin-right: 2.5%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.24px;
}

#redirect-btn {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 5%;
  height: 56px;
  padding: 10px 24px;
  font-size: medium;
  color: #2c7040;
  border-radius: 10px;
  background: #a0db1d;
  font-weight: 800;
  font-style: normal;
  line-height: 20px;
  letter-spacing: -0.2px;
  width: 90%;
  border: none;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.32);
  animation: bounce-in-right 0.4s ease;
}

@keyframes bounce-in-right {
  0% {
    opacity: 0;
    transform: translateY(2000px);
  }
  40% {
    opacity: 1;
    transform: translateY(-30px);
  }
  80% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0);
  }
}

.dismiss-alert-button {
  background: none;
  border: none;
  padding: 0;
  color: #606060;
  right: 2.5%;
  margin-left: 0;
  scale: 2;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $pj-color-green;
  font-size: 40px;
  background-color: rgba(150, 150, 150, 0.4);
  width: 100vw;
  height: 100vh;
  z-index: 1000;
}

.slide ul {
  list-style-type: disc;
}

.slide ul li {
  text-align: left;
  margin-bottom: 2rem;
  font-size: 20px;
  font-weight: 400;
  line-height: 138%;
}
</style>
